import UploadCaidas from "./UploadCaidas";

export default UploadCaidas;